module.exports = __webpack_public_path__ + "img/Group 28814.d4296390.svg";